import React, { useContext } from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import FieldsContainer from './components/Fields/Fields.container';
import FieldContainer from './components/Field/Field.container';
import { PrivateRouteElement } from './PrivateRoute';
import { LanguageContext } from './contexts/LanguageContext';
import PolicyMakers from './components/PolicyMakers/PolicyMakers';
export default function SatfarmRoutes() {
  useContext(LanguageContext);

  return (
    <>
      <BrowserRouter basename={process.env.REACT_APP_ROUTER_BASENAME}>
        <Routes>
          <Route element={<PrivateRouteElement />}>
            <Route path={'/'} element={<FieldsContainer />} />
            <Route path={'/policy-makers'} element={<PolicyMakers />} />
            <Route path={'/:fieldId'} element={<FieldContainer />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}
